import * as React from 'react'
import { Button, TYPE } from '../Button'

import classNames from 'classnames'
import Loader from 'components/Preloader/Loader'
import './FormBox.scss'

interface FormBoxProps {
  formName?: string
  buttonText: string | JSX.Element
  buttonType?: TYPE
  buttonCutOff?: 'left' | 'right' | 'none'
  buttonClick?: any
  buttonDisabled?: boolean
  inProgress?: boolean
  expanded?: 'expanded' | 'huge'
  rightStick?: boolean
  linkText?: string | JSX.Element
  linkUrl?: (event: React.MouseEvent<HTMLButtonElement>) => void
  shadow?: boolean
  children?: React.ReactNode | undefined
}

const FormBox: React.FC<FormBoxProps> = props => {
  const divClasses = classNames(
    'srprs-formBox',
    props.linkUrl !== null ? 'has-link' : '',
    props.expanded || '',
    props.rightStick ? 'right-stick' : '',
    props.shadow ? 'with-shadow' : '',
  )
  return (
    <React.Fragment>
      <div className={divClasses}>
        <Loader hidden={!props.inProgress} />
        <div
          id={props.formName ? `${props.formName}-form` : undefined}
          className="srprs-formBox-form"
        >
          {props.children}
        </div>
        <div
          id={props.formName ? `${props.formName}-button` : undefined}
          className="srprs-formBox-button"
        >
          <Button
            type={props.buttonType || TYPE.primary}
            cutOff={props.buttonCutOff || 'left'}
            onClick={props.buttonClick}
            submit={true}
            disabled={props.buttonDisabled}
          >
            <span>{props.buttonText}</span>
          </Button>
        </div>
      </div>
      {props.linkUrl == null ? (
        ''
      ) : (
        <div id={props.formName ? `${props.formName}-link` : undefined}>
          <Button
            type={TYPE.inlinetext}
            className={'pull-right'}
            onClick={props.linkUrl}
            disabled={props.buttonDisabled}
          >
            {props.linkText}
          </Button>
        </div>
      )}
    </React.Fragment>
  )
}

FormBox.defaultProps = {
  shadow: true,
}

export default FormBox
